<template>
  <div class="content">
    <div class="contv">
      <!-- <button class="btn btn-close" @click="winClose">关闭</button> -->
      <div class="title">
        <img src="./../assets/icon1.png" alt="" class="logo"/>
        <p>AI事项创建</p>
      </div>
      <div class="textBox" v-if="!isOver&&!audioType">
        <textarea
          v-model="text"
          class="text"
          placeholder="在此手动或语音输入事项名称、耗时、时间等信息AI将自动计算该事项名称对应要素，并填入部分事项内容。试试这样说：我要在今天十点开一个一小时的会议"
        ></textarea>
        <button
          class="btn-read"
          @click="getSound"
          v-if="client == 'ios'"
        ></button>
        <div class="readBtnBox" style="display: none">
          <button id="btns startBtn" @click="translationStart">开始录音</button>
          <button id="btns endBtn" @click="translationEnd">结束录音</button>
        </div>
        <div class="btnBox btn1">
          <button class="btn btn-sub" @click="btnSub">{{ btnTxt }}</button>
        </div>
      </div>
      <div class="textBox text1" v-if="isOver&&!audioType">
        <div class="text">
          <p v-if="aiTxt.title">事项名称：{{ aiTxt.title }}</p>
          <p v-if="aiTxt.schedule_type">
            事项类型：{{
              aiTxt.schedule_type == 1
                ? "日程"
                : aiTxt.schedule_type == 2
                ? "清单"
                : aiTxt.schedule_type == 3
                ? "待办"
                : ''
            }}
          </p>
          <p v-if="aiTxt.begintime">开始时间：{{ aiTxt.begintime }}</p>
          <p v-if="aiTxt.endtime">截止时间：{{ aiTxt.endtime }}</p>
          <p v-if="aiTxt.category">
            维度：{{
              aiTxt.category == 1
                ? "事业"
                : aiTxt.category == 2
                ? "心灵"
                : aiTxt.category == 3
                ? "家庭"
                : aiTxt.category == 4
                ? "人脉"
                : aiTxt.category == 5
                ? "理财"
                : aiTxt.category == 6
                ? "娱乐"
                : aiTxt.category == 7
                ? "学习"
                : aiTxt.category == 8
                ? "健康"
                : ""
            }}
          </p>
          <p v-if="aiTxt.contime">耗时：{{ aiTxt.contime ? aiTxt.contime < 0 ? 0 : aiTxt.contime : 0 }}分钟</p>
          <p v-if="aiTxt.important">
            事项重要性：{{
              aiTxt.important == 1
                ? "青蛙级"
                : aiTxt.important == 2
                ? "重要"
                : aiTxt.important == 3
                ? "不重要"
                : ''
            }}
          </p>
        </div>
        <div class="btnBox btn2" >
          <button
            @click="btnChange(item)"
            class="btn"
            :class="'btn' + item.id"
            v-bind:key="item.id"
            v-for="item in btnList"
          >
            {{ item.title }}
          </button>
        </div>
      </div>
      <div class="textBox text2" v-if="audioType">
        <div class="text">
          <p>{{audioTxt}}</p>
        </div>
        <div class="btnBox btn1" >
          <button @click="audioStosp" class="btn">
            确定
          </button>
        </div>
      </div>
    </div>
    <div class="msgBox" v-if="isLoading">
      <div class="contv">
        <img src="./../assets/ailoading.png" />
        <p>正在生成AI事项请稍等...</p>
      </div>
    </div>
    <div class="msgBox loadBox" v-if="isBtn">
      <div class="contv" style="background-color: transparent">
        <img src="./../assets/loading.gif" alt="" style="" />
      </div>
    </div>
  </div>
</template>
<script>
var editData = "";
import VConsole from "vconsole";
import TTSRecorder from "../../static/TTSRecorder";
const ttsRecorder = new TTSRecorder();
// var Vconsole = new VConsole();

import IatRecorder from "../../static/IatRecorder";
const iatRecorder = new IatRecorder();

import { getIsBroadcast, aiConvert, addAiMatter,aiSmallModel,baiduAiConvert } from "@/assets/api/api";
export default {
  data() {
    return {
      text: "",
      message: [
        {
          role: "system",
          // content: "将该句话拆分为下几个字段：事项名称，开始时间，截止日期（你要根据今天的日期把它转化成一个具体的日期格式。比如：2023-06-30 22:00。），耗时（把耗时转化成多少分钟），分析事项类型（分为固定时间，弹性时间，待办），分析事项维度（分为事业，家庭，理财，人脉，健康，学习，娱乐，心灵），分析事项的重要性（分为非常重要，重要，不重要），分析事项难度（分为复杂事项，一般难度事项，视觉类简单事项，听觉类简单事项），分析复用容器（分为可同时安排所有事项，不可同时安排其他事项，可同时安排视觉类简单事项，可同时安排听觉类简单事项）"
          content:
            "'根据该句话分析出以下几个字段：\
             事项名称，\
             分析事项类型（分为固定时间，弹性时间，待办，如果为固定时间分析出开始时间，如果为弹性时间分析出截止时刻，开始时间和截止时刻你要根据今天的日期把它转化成一个具体的日期格式。比如：2023-6-30 22:00。），\
             耗时（把耗时转化成多少分钟），\
             分析事项维度（分为事业，家庭，理财，人脉，健康，学习，娱乐，心灵），\
             分析事项的重要性（分为非常重要，重要，不重要），\
             分析事项难度（分为复杂事项，一般难度事项，视觉类简单事项，听觉类简单事项），\
             分析复用容器（分为可同时安排所有事项，不可同时安排其他事项，可同时安排视觉类简单事项，可同时安排听觉类简单事项），\
             如果该事项为弹性时间则分析延期性（分为不可延期，当天可延期，可延期，可不做）",
        },
        {
          role: "user",
          content: "",
        },
        {
          role: "system",
          content: "今天的日期是：2023年07月02日",
        },
      ],
      result: "",
      btnList: [
        { id: 1, title: "生成计划" },
        { id: 2, title: "重新输入" },
        { id: 3, title: "进行编辑" },
      ],
      isOver: false,
      is_broadcast: "", //是否语音播报 0：否 1：是
      aiTxt: "",
      client: "", //ios or 安卓
      btnTxt: "确定",
      token: "",
      editObj: {},
      isLoading: false,
      loadTxt: "",
      RecordTime: 60,
      countdown: "",
      isRecord: false,
      ment: null,
      isBtn: false,
      audioType:false,
      audioTxt:'',
    };
  },
  mounted() {
    var that = this;
    this.client = this.getParam("client");
    this.font_resize();
    this.getBroadcastData();
    this.currentTime();
    window.javacalljswithargs = (res) => {
      this.javacalljswithargs(res);
    };
    window.audioStosp = this.audioStosp;
  },

  created() {},
  methods: {
    getParam(name) {
      var url = window.location.href;
      if (!url.split("?")[1]) {
        return false;
      }
      var urlParam = url.split("?")[1];
      var paramArr = urlParam.split("&");
      var param = {};
      for (var i = 0; i < paramArr.length; i++) {
        param[paramArr[i].split("=")[0]] = paramArr[i].split("=")[1];
      }
      if (param[name]) {
        return param[name];
      } else {
        return null;
      }
    },
    currentTime() {
      var date = new Date();
      var year = date.getFullYear(); //月份从0~11，所以加一
      let month = date.getMonth();
      var dateArr = [
        date.getMonth() + 1,
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
      ];
      //如果格式是MM则需要此步骤，如果是M格式则此循环注释掉
      for (var i = 0; i < dateArr.length; i++) {
        if (dateArr[i] >= 1 && dateArr[i] <= 9) {
          dateArr[i] = "0" + dateArr[i];
        }
      }
      var strDate = year + "年" + dateArr[0] + "月" + dateArr[1] + "日";
      this.message[2].content = "今天的日期是：" + strDate;
    },

    getBroadcastData() {
      var that = this;
      this.token = this.getParam("token");
      getIsBroadcast(this.token)
        .then((res) => {
          var res = res.data;
          if (res.code == 200) {
            that.is_broadcast = res.data.is_broadcast;
          } else {
            alert(res.msg);
          }
        })
        .catch((err) => {
          // console.log(err,'==err==')
        });
    },

    audioPlays(text, voiceName) {
      ttsRecorder.setParams({
        voiceName,
        tte: "UTF8",
        text,
      });
      if (["init", "endPlay", "errorTTS"].indexOf(ttsRecorder.status) > -1) {
        ttsRecorder.start();
      } else {
        ttsRecorder.stop();
      }
    },

    audioStosp() {
      var client = this.client;
      var btnList = this.btnList;
      this.audioType = false;
      if (client == "android") {
        window.injectedObject.onClose();
      } else if (client == "ios") {
        window.webkit.messageHandlers.onClose.postMessage(btnList);
      }
    },

    winClose() {
      var client = this.client;
      var btnList = this.btnList;
      if (client == "android") {
        window.injectedObject.onClose();
      } else if (client == "ios") {
        window.webkit.messageHandlers.onClose.postMessage(btnList);
      }
    },

    font_resize() {
      var size = (document.documentElement.clientWidth / 750) * 100;
      document.querySelector("html").style.fontSize = size + "px";
    },

    translationStart() {
      this.result = "请稍后...";
      iatRecorder.start();
    },

    translationEnd() {
      var that = this;
      iatRecorder.stop();
      setTimeout(function () {
        that.text = iatRecorder.resultText;
        that.result = iatRecorder.resultText;
        that.message[1].content = "“" + that.text + "”";
        // that.openai(that.message);
        that.baiduAi(that.text);
      }, 1000);
    },

    baiduAi(e){
      var that = this;
      baiduAiConvert({title:e}, this.token).then((res) => {
        var res = res.data;
        if (res.code == 200) {
          that.isOver = true;
          that.isLoading = false;
          that.aiTxt = res.data;
          that.editObj = res.data;
          editData = res.data;
        } else {
          alert(res.msg);
        }
        that.isLoading = false;
        that.loadTxt = "loading...";
        that.btnTxt = '确定';
      });
    },

    openai(e) {
      var that = this;
      var time = 15;
      var timeout = '';
      const { OpenAIClient, AzureKeyCredential } = require("@azure/openai");
      var message = e;
      async function main(e) {
        const client = new OpenAIClient(
          "https://zens.openai.azure.com/",
          new AzureKeyCredential("06aed28a27a44f76ab9419061a2354ba")
        );
        const deploymentId = "zens";
        const result = await client.getChatCompletions(deploymentId, message);
        clearInterval(timeout);
        for (const choice of result.choices) {
          that.result = choice.message.content;
          that.getAi();
        }
      }

      main().catch((err) => {
        console.log(err);
        alert('识别失败，请重新输入');
        clearInterval(timeout);
        that.isLoading = false;
        that.btnTxt = '确定';
      });

      timeout = setInterval(function(res){
        time--;
        console.log(time,'time')
        if(time == 0){
            clearInterval(timeout);
            that.isLoading = false;
            that.btnTxt = '确定';
            var client = that.client;
            var editObj = {
              aid: null,
              begintime: null,
              category: null,
              contime: null,
              delay: null,
              endtime: null,
              important: null,
              schedule_type: null,
              title: that.text,
            };
            if (client == "android") {
              window.injectedObject.Editing(editObj.aid);
            } else if (client == "ios") {
              window.webkit.messageHandlers.Editing.postMessage(editObj);
            }
        }
      },1000)
    },

    getAi() {
      var that = this;
      var obj = {
        content: this.result,
        title: this.text
      };
      aiConvert(obj, this.token).then((res) => {
        var res = res.data;
        if (res.code == 200) {
          that.isOver = true;
          that.aiTxt = res.data;
          that.editObj = res.data;
          editData = res.data;
        } else {
          alert(res.msg);
        }
        that.isLoading = false;
        that.loadTxt = "loading...";
      });
    },

    getCreate() {
      var that = this;
      if(that.aiTxt.schedule_type ==1){
        if(that.aiTxt.contime <= 0){
          alert('您的耗时不规范，请手动进行编辑！');
          that.isBtn  = false;
          return false;
        }
      };
      if(that.aiTxt.schedule_type == 2){
        if(that.aiTxt.contime <= 0){
          alert('您的耗时不规范，请手动进行编辑！');
          that.isBtn  = false;
          return false;
        }
        if(that.aiTxt.endtime <= that.aiTxt.begintime){
          alert('您的截止时间不正确，请手动进行编辑！');
          that.isBtn  = false;
          return false;
        }
      }
      var obj = {
        aid: that.aiTxt.aid,
        begintime: that.aiTxt.begintime,
        category: that.aiTxt.category,
        // complex: that.aiTxt.complex,
        contime: that.aiTxt.contime,
        endtime: that.aiTxt.endtime,
        important: that.aiTxt.important,
        // overlapping: that.aiTxt.overlapping,
        schedule_type: that.aiTxt.schedule_type,
        title: that.aiTxt.title,
      };
      addAiMatter(obj, this.token).then((res) => {
        var res = res.data;
        if (res.code == 200) {
          if (that.is_broadcast == 1) {
            that.audioTxt = res.data.msg;
            that.audioPlays(res.data.msg, "xiaoyan");
            that.audioType = true;
          } else {
            var client = that.client;
            var btnList = that.btnList;
            if (client == "android") {
              window.injectedObject.onClose();
            } else if (client == "ios") {
              window.webkit.messageHandlers.onClose.postMessage(btnList);
            }
          }
        } else {
          alert(res.msg);
        };
        that.isBtn = false;
      });
    },

    btnSub() {
      var that = this;
      var btnList = this.btnList;
      if (that.isRecord) {
        clearInterval(that.countdown);
        that.RecordTime = 60;
        that.countdown = "";
        that.btnTxt = "确定";
        that.isRecord = false;
        window.webkit.messageHandlers.endRecord.postMessage(btnList);
        return false;
      }
      if (this.text == "") {
        alert("请输入文本！");
        return false;
      }
      this.isLoading = true;
      this.loadTxt = "loading...";
      this.btnTxt = "生成中";
      this.message[1].content = "“" + this.text + "”";
      // this.openai(this.message);
      this.aiSmall();
    },

    aiSmall(){
      var that = this;
      var obj = {
        content:this.text
      }
      aiSmallModel(obj, this.token).then((res) => {
        var res = res.data;
        console.log(res,'==aiSmall==')
        if (res.code == 200) {
          if(res.data.schedule_type == 3){
            // that.openai(that.message);
            that.baiduAi(that.text);
            return false;
          };
          that.isOver = true;
          that.aiTxt = res.data;
          that.editObj = res.data;
          editData = res.data;
        } else {
          alert(res.msg);
        };
        that.isLoading = false;
        that.isBtn = false;
        that.btnTxt = '确定';
      });
    },

    btnChange(e) {
      var client = this.client;
      var editObj = this.editObj;
      if (this.isBtn) {
        return false;
      };
      this.isBtn = true;
      if (e.id == 1) {
        this.getCreate();
      } else if (e.id == 2) {
        this.isBtn = false;
        this.isOver = false;
        this.text = "";
        this.btnTxt = "确定";
      } else {
        if (client == "android") {
          window.injectedObject.Editing(editObj.aid);
        } else if (client == "ios") {
          window.webkit.messageHandlers.Editing.postMessage(editObj);
        }
      }
    },

    getSound() {
      var that = this;
      var client = this.client;
      var btnList = this.btnList;
      this.btnTxt = "结束录音";
      if (client == "android") {
        window.injectedObject.startRecord();
      } else if (client == "ios") {
        that.isRecord = true;
        that.countdown = setInterval(function () {
          that.RecordTime--;
          that.btnTxt = "结束录音--倒计时：" + that.RecordTime + "s";
          if (that.RecordTime == 0) {
            clearInterval(that.countdown);
            that.RecordTime = 60;
            that.countdown = "";
            that.btnTxt = "确定";
            that.isRecord = false;
            window.webkit.messageHandlers.endRecord.postMessage(btnList);
          }
        }, 1000);
        window.webkit.messageHandlers.startRecord.postMessage(btnList);
      }
    },

    // app回调
    javacalljswithargs(res) {
      var that = this;
      var client = this.client;
      console.log(res);
      // that.isLoading = true;
      that.text = res;
      that.result = res;
      // that.message[1].content = '“' + that.text + "”";
      // that.openai(that.message);
      that.btnTxt = "确定";
      that.isRecord = false;
      if (client == "ios") {
        if (that.isRecord) {
          clearInterval(that.countdown);
          that.RecordTime = 60;
          that.countdown = "";
          // that.btnTxt = '确定';
          // that.isRecord = false;
        }
      }
    },
  },
};
</script>
<style scoped>
.contv {
  width: 6.9rem;
  height: 7.5rem;
  background-color: #fff;
  border-radius: 0.2rem;
  padding: 0.31rem 0 0.42rem;
  box-sizing: border-box;
}
.logo {
  width: .92rem;
  height: 0.89rem;
  display: block;
  margin: 0 auto;
}

.title {
}

.title p {
  font-size: 0.34rem;
  color: #3d3d3d;
  font-weight: bold;
  text-align: center;
  margin-top: .1rem;
}

.textBox {
  width: 6.3rem;
  /* height: 4.03rem; */
  background-color: #f8f8f8;
  border-radius: 0.1rem;
  display: block;
  margin: 0.16rem auto 0;
  padding: 0.1rem;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
}

.textBox .text {
  width: 100%;
  height: 3rem;
  font-size: 0.26rem;
  color: #898a95;
  display: block;
}
.textBox.text2 .text,
.textBox.text1 .text{
  height: 4.03rem;
  overflow-y: auto;
  overflow-x: hidden;
}

.textBox .btn-read {
  background-image: url(./../assets/read-icon.png);
  width: 0.68rem;
  height: 0.68rem;
  background-size: 100% 100%;
  display: block;
  margin: 0.08rem auto 0;
}

.textBox p {
  font-size: 0.26rem;
  color: #3d3d3d;
  line-height: 0.36rem;
  padding: 0.2rem;
}

.text1 pre {
  font-size: 0.26rem;
  white-space: pre-line;
  height: 100%;
  overflow-y: auto;
  overflow-x: hide;
}
.btn1 .btn {
  width: 3.97rem;
  height: 0.81rem;
  background-color: #D9F4F1;
  border-radius: 0.36rem;
  display: block;
  margin: 0.33rem auto 0;
  color: #00B7BC;
}

.btn2 {
  text-align: center;
}

.btn2 .btn {
  display: inline-block;
  width: 1.9rem;
  height: 0.8rem;
  background-color: #00D4BF;
  color: #fff;
  border-radius: 0.2rem;
  margin: 0 0.05rem;
}

.readBtnBox {
  font-size: 0;
  width: 100%;
  text-align: center;
}

.readBtnBox button {
  display: inline-block;
  font-size: 0.26rem;
  margin: 0 0.2rem;
}

.btn-close {
  position: absolute;
  top: 0.1rem;
  right: 0.1rem;
  color: #3d3d3d;
  font-size: 0.3rem;
  line-height: 0.45rem;
  font-weight: bold;
}

.msgBox {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.msgBox .contv {
  width: 3.2rem;
  height: 2.7rem;
  display: inline-block;
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 0.2rem;
}

.msgBox .contv p {
  font-size: 0.22rem;
  line-height: 0.28rem;
  color: #fff;
  text-align: center;
  margin-top: 0.24rem;
  font-weight: bold;
}

.msgBox .contv img {
  width: 1.04rem;
  height: 1.18rem;
  display: block;
  margin: 0 auto;
}

.loadBox .contv {
  width: auto;
  height: auto;
  background-color: transparent;
}

.loadBox .contv img {
  width: 2rem;
  height: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue